import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import closeIcon from '../../../../images/icons/close.svg';
import crueltyFreeIcon from '../../../../images/value_tags/cruelty_free.svg';
import cleanIcon from '../../../../images/value_tags/clean.svg';
import glutenFreeIcon from '../../../../images/value_tags/gluten_free.svg';
import sulfateFreeIcon from '../../../../images/value_tags/sulfate_free.svg';
import veganIcon from '../../../../images/value_tags/vegan.svg';
import nanoparticleFreeIcon from '../../../../images/value_tags/nanoparticle_free.svg';
import reefSafeIcon from '../../../../images/value_tags/reef_safe.svg';
import siliconeFreeIcon from '../../../../images/value_tags/silicone_free.svg';
import Loader from '../../../checkout/components/loader/Loader';
import ClearForMeIngredients from './clear_for_me_ingredients/ClearForMeIngredients';

import './IngredientsList.sass';

const VALUE_TAGS_IMAGES = {
  cruelty_free: crueltyFreeIcon,
  clean: cleanIcon,
  gluten_free: glutenFreeIcon,
  vegan: veganIcon,
  sulfate_free: sulfateFreeIcon,
  nanoparticle_free: nanoparticleFreeIcon,
  reef_safe: reefSafeIcon,
  silicone_free: siliconeFreeIcon,
};
const PRODUCT_API_URL = 'https://clickable-api.clearforme.com/api/app/products/details/v2';
const CLIENT_NAME = 'volition beauty';

function IngredientsList(props) {
  const {
    text, detailedIngredients, valueTags, clearForMeToken, upc,
  } = props;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [clearForMeData, setClearForMeData] = useState({});

  const REQUEST_OPTIONS = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${clearForMeToken}`,
    },
    dataType: 'json',
  };

  const toggleModal = () => {
    setModalIsOpen((prevModalIsOpen) => !prevModalIsOpen);
  };

  useEffect(() => {
    fetch(`${PRODUCT_API_URL}?upc=${upc}&clientname=${CLIENT_NAME}`, REQUEST_OPTIONS)
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          setClearForMeData(result);
        },
        () => {
          setLoading(false);
        },
      );
  }, []);

  const ingredientsAreMissing = !clearForMeData.productIngredients
    || clearForMeData.productIngredients.every(
      (ingredient) => ingredient.ingredientGroup.every((group) => group.ingredients.every((item) => item.ingredientName === 'n/a')),
    );

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      <ClickableDiv className="full-list-link" onClick={toggleModal}>
        View full list of ingredients
      </ClickableDiv>
      <Modal isOpen={modalIsOpen} className="ingredients-modal" ariaHideApp={false}>
        <div className="content">
          <button className="close-modal" type="button" onClick={toggleModal}>
            <img alt="close" src={closeIcon} width="24" height="24" />
          </button>
          <div className="body">
            { !ingredientsAreMissing && (
              <>
                <div className="tooltip">Click an ingredient to learn more</div>
                { loading && <Loader />}
                <ClearForMeIngredients
                  ingredients={clearForMeData.productIngredients}
                  requestOptions={REQUEST_OPTIONS}
                  clientName={CLIENT_NAME}
                />
              </>
            )}
            { (clearForMeData.error || ingredientsAreMissing) && detailedIngredients && (
            <div className="text" dangerouslySetInnerHTML={{ __html: detailedIngredients }} />
            )}
            { (clearForMeData.error || ingredientsAreMissing) && !detailedIngredients && (
            <p className="text">Ingredient list currently not available.</p>
            )}
          </div>
          <div className="value-tags">
            {valueTags.map((tag) => (
              <div className="value-tag" key={tag}>
                <img src={VALUE_TAGS_IMAGES[tag]} alt={tag.split('_').join(' ')} />
                <div className="name">
                  {tag.split('_').join(' ')}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}

IngredientsList.propTypes = {
  text: PropTypes.string.isRequired,
  detailedIngredients: PropTypes.string,
  valueTags: PropTypes.arrayOf(PropTypes.string),
  clearForMeToken: PropTypes.string,
  upc: PropTypes.string.isRequired,
};

IngredientsList.defaultProps = {
  detailedIngredients: undefined,
  clearForMeToken: null,
  valueTags: [],
};

export default IngredientsList;
